<template>
  <div class="frame20_body">
    <div class="frame20">
      <div class="frame20_top">
        RPS股价相对强度
        <img
          src="../../../../public/img/shares_Info/close.png"
          alt=""
          @click="frame20_close"
        />
      </div>
      <div class="frame20_content">
        <div class="frame20_content_title">RPS股价相对强度</div>
        <div class="frame20_content_text">
          【释义】：相对价格强度，以RPS60为例，指在过去的60个交易日内，该股票的价格涨幅超过了市场上多少的股票。例如，RPS60为85，表示该股在过去60日内的价格涨幅超过了市场上85%的股票，走势强劲。
        </div>
        <!-- <div class="frame20_content_text">【算法】：市盈率=股票指定交易日期的收盘价/预测每股收益（综合值）  </div> -->
        <div class="frame20_content_text">【单位】：%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    frame20_close() {
      this.$emit("frame20_close");
    },
  },
};
</script>

<style scoped>
.frame20_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame20 {
  width: 448px;
  /* height: 920px; */
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame20_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame20_content {
  margin-top: 28px;
}
.frame20_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame20_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame20_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>